export class AddressModel {
    addressId?: number;
    applicantId?: number;
    applicationId?: number;
    fullAddress?: string;
    streetAddress: string;
    addressLine2?: string;
    city: string;
    state: string;
    zipCode: string;
    addressUsage: string; // 0 = Home | 1 = Mailing |  2 = Temporary
    type?: string; // 0 = Business | 1 = Residential
    county: string;
    country: string;
    current?: boolean;

    constructor() {
        this.addressId = null;
        this.fullAddress = '';
        this.streetAddress = '';
        this.addressLine2 = '';
        this.city = '';
        this.state = '';
        this.zipCode = '';
        this.addressUsage = 'PRIMARY';
        this.current = true;
        this.county = '';
        this.country = '';
    }
}
